/** A page's picture, loaded on mount, with its caption; amber when it is the doubt. */
import { useEffect, useState } from "react";

/** A page's preview image url, or null when there is none. */
export type Previewer = (page: number) => Promise<string | null>;

export function Thumb({
  page,
  onPreview,
  caption,
  warn = false,
}: {
  page: number;
  onPreview?: Previewer;
  caption: string;
  warn?: boolean;
}) {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    let live = true;
    void onPreview?.(page).then((u) => live && setUrl(u));
    return () => {
      live = false;
    };
  }, [page, onPreview]);
  return (
    <figure className={`thumb${warn ? " thumb--warn" : ""}`}>
      <span className="thumb__page">
        {url && <img src={url} alt={`Page ${page}`} loading="lazy" />}
      </span>
      <figcaption className="thumb__caption">{caption}</figcaption>
    </figure>
  );
}
